<div class="register-wrapper large-viewport">
  <div class="logo">
    <img src="assets/images/transend-logo-wide.svg" alt="Logo" class="logo-image" />
  </div>

  <div class="register-container mat-typography">
    <h2 class="register-title">New User Account</h2>

    @if (errorMessage.length > 0) {
      <p class="error-message">
        {{ errorMessage }}
      </p>
    }

    <form class="register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="form-field-group">
        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" required />
            @if (registerForm.get('username')?.hasError('required')) {
              <mat-error>
                Username is required.
              </mat-error>
            }
            @if (registerForm.get('username')?.hasError('minlength')) {
              <mat-error>
                Username must be at least 6 characters long.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Password</mat-label>

            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              required
              />

            <!-- Eye icon -->
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
              [attr.aria-pressed]="!hidePassword"
              >
              <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>

            @if (registerForm.get('password')?.touched && registerForm.get('password')?.invalid) {
              <div class="mat-errors">
                @if (registerForm.get('password')?.hasError('required')) {
                  <mat-error>
                    Password is required.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('minlength')) {
                  <mat-error>
                    Password must be at least 12 characters long.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('maxlength')) {
                  <mat-error>
                    Password must not exceed 128 characters.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('uppercase')) {
                  <mat-error>
                    Password must contain at least one uppercase letter.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('lowercase')) {
                  <mat-error>
                    Password must contain at least one lowercase letter.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('digit')) {
                  <mat-error>
                    Password must contain at least one digit.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('special')) {
                  <mat-error>
                    Password must contain at least one special character.
                  </mat-error>
                }
                @if (registerForm.get('password')?.hasError('identical')) {
                  <mat-error>
                    Password cannot have more than 2 identical characters in a row.
                  </mat-error>
                }
              </div>
            }
          </mat-form-field>
        </div>

        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Confirm Password</mat-label>

            <input
              matInput
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirmPassword"
              required
              />

            <!-- Eye icon -->
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="hideConfirmPassword = !hideConfirmPassword"
              [attr.aria-label]="hideConfirmPassword ? 'Show confirm password' : 'Hide confirm password'"
              [attr.aria-pressed]="!hideConfirmPassword"
              >
              <mat-icon>{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>

            @if (registerForm.get('confirmPassword')?.hasError('required')) {
              <mat-error>
                Confirm Password is required.
              </mat-error>
            }
            @if (
              registerForm.get('confirmPassword')?.hasError('passwordMismatch') &&
              registerForm.get('confirmPassword')?.touched
              ) {
              <mat-error
                >
                Passwords do not match.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Security Question 1</mat-label>
            <mat-select formControlName="securityQuestion1" required>
              @for (question of securityQuestions; track question) {
                <mat-option [value]="question">{{ question }}</mat-option>
              }
            </mat-select>
            @if (registerForm.get('securityQuestion1')?.hasError('required')) {
              <mat-error>
                Security Question 1 is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Answer 1</mat-label>
            <input matInput type="text" formControlName="answer1" required />
            @if (registerForm.get('answer1')?.hasError('required')) {
              <mat-error>
                Answer 1 is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Security Question 2</mat-label>
            <mat-select formControlName="securityQuestion2" required>
              @for (question of securityQuestions; track question) {
                <mat-option [value]="question">{{ question }}</mat-option>
              }
            </mat-select>
            @if (registerForm.get('securityQuestion2')?.hasError('required')) {
              <mat-error>
                Security Question 2 is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Answer 2</mat-label>
            <input matInput type="text" formControlName="answer2" required />
            @if (registerForm.get('answer2')?.hasError('required')) {
              <mat-error>
                Answer 2 is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="divider">
        <p>Enter the following data as it appears on your statement</p>
      </div>

      <div class="form-field-group">
        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>First Name</mat-label>
            <input matInput type="text" formControlName="firstName" required />
            @if (registerForm.get('firstName')?.hasError('required')) {
              <mat-error>
                First Name is required.
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" formControlName="lastName" required />
            @if (registerForm.get('lastName')?.hasError('required')) {
              <mat-error>
                Last Name is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group">
        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" required />
            @if (registerForm.get('email')?.hasError('required')) {
              <mat-error>
                Email is required.
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-field smushed">
          <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="pickerLarge" formControlName="dateOfBirth" required (input)="onDateOfBirthInput($event)" />
            <mat-datepicker-toggle matSuffix [for]="pickerLarge"></mat-datepicker-toggle>
            <mat-datepicker #pickerLarge></mat-datepicker>
            @if (registerForm.get('dateOfBirth')?.hasError('required')) {
              <mat-error>
                Date of Birth is required.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="action-buttons">
        <button mat-raised-button class="back-btn" type="button" (click)="_router.navigate(['/login'])">Back</button>
        <button mat-raised-button color="primary" class="register-btn" type="submit"
          [disabled]="isSubmitting || !registerForm.valid">
          Register
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Small viewport -->
<div class="register-wrapper small-viewport">
  <div class="logo">
    <img src="assets/images/transend-logo-wide.svg" alt="Logo" class="logo-image" />
  </div>

  <div class="register-container mat-typography">
    <h2>New User Account</h2>

    @if (errorMessage.length > 0) {
      <p class="error-message">
        {{ errorMessage }}
      </p>
    }

    <form class="register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="form-field-group" style="flex-direction: column;">

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Password</mat-label>

          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            required
            />

          <!-- Eye icon -->
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
            [attr.aria-pressed]="!hidePassword"
            >
            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>

          @if (registerForm.get('password')?.touched && registerForm.get('password')?.invalid) {
            <div class="mat-errors">
              @if (registerForm.get('password')?.hasError('required')) {
                <mat-error>
                  Password is required.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('minlength')) {
                <mat-error>
                  Password must be at least 12 characters long.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('maxlength')) {
                <mat-error>
                  Password must not exceed 128 characters.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('uppercase')) {
                <mat-error>
                  Password must contain at least one uppercase letter.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('lowercase')) {
                <mat-error>
                  Password must contain at least one lowercase letter.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('digit')) {
                <mat-error>
                  Password must contain at least one digit.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('special')) {
                <mat-error>
                  Password must contain at least one special character.
                </mat-error>
              }
              @if (registerForm.get('password')?.hasError('identical')) {
                <mat-error>
                  Password cannot have more than 2 identical characters in a row.
                </mat-error>
              }
            </div>
          }
        </mat-form-field>


        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Confirm Password</mat-label>

          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            required
            />

          <!-- Eye icon -->
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="hideConfirmPassword ? 'Show confirm password' : 'Hide confirm password'"
            [attr.aria-pressed]="!hideConfirmPassword"
            >
            <mat-icon>{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>

          @if (registerForm.get('confirmPassword')?.hasError('required')) {
            <mat-error>
              Confirm Password is required.
            </mat-error>
          }
          @if (
            registerForm.get('confirmPassword')?.hasError('passwordMismatch') &&
            registerForm.get('confirmPassword')?.touched
            ) {
            <mat-error
              >
              Passwords do not match.
            </mat-error>
          }
        </mat-form-field>


        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Security Question 1</mat-label>
          <mat-select formControlName="securityQuestion1" required>
            @for (question of securityQuestions; track question) {
              <mat-option [value]="question">{{ question }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Answer 1</mat-label>
          <input matInput type="text" formControlName="answer1" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Security Question 2</mat-label>
          <mat-select formControlName="securityQuestion2" required>
            @for (question of securityQuestions; track question) {
              <mat-option [value]="question">{{ question }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Answer 2</mat-label>
          <input matInput type="text" formControlName="answer2" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>First Name</mat-label>
          <input matInput type="text" formControlName="firstName" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" formControlName="lastName" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" required />
        </mat-form-field>

        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Date of Birth</mat-label>
          <input matInput [matDatepicker]="pickerSmall" formControlName="dateOfBirth" required (input)="onDateOfBirthInput($event)" />
          <mat-datepicker-toggle matSuffix [for]="pickerSmall"></mat-datepicker-toggle>
          <mat-datepicker #pickerSmall></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="action-buttons">
        <button mat-raised-button class="back-btn" type="button" (click)="_router.navigate(['/login'])">Back</button>
        <button mat-raised-button color="primary" class="register-btn" type="submit"
          [disabled]="isSubmitting || !registerForm.valid">
          Register
        </button>
      </div>
    </form>

  </div>
</div>